exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".compare_content > .column > .column {\n  padding-top: 3em;\n  padding-bottom: 3em;\n}\n.specColumns > p {\n  display: inline-block;\n}\n.specColumns:not(:first-child) {\n  margin-top: 3em;\n}\n.basicInfo h1 > small {\n  font-size: 0.5em;\n  margin-left: 0.5em;\n}\n.multiUnitSpec:not(:first-child) {\n  margin: 6em 2em 3em;\n}\n.noUnitCompare {\n  text-align: center;\n  margin-top: 9em;\n  margin-bottom: 9em;\n}\n.ppItemBox:not(:first-child) {\n  margin-top: 6em;\n}\n.compare_content .ui.horizontal.divider {\n  margin-bottom: 3em;\n}\na.ui.button.viewMoreButton {\n  margin: 0 auto;\n  width: 10em;\n}\nh1 {\n  font-size: 1.6em;\n}\n.basicInfo > .column.unitSpecButtonCol {\n  padding-top: 0;\n}\n.ui.horizontal.divider:not(:first-child) {\n  margin-top: 3em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader!./~/less-loader!./src/styles/containers/project/units/unitsCompare.less
// module id = 2873
// module chunks = 0